exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.recaptcha-wrapper[data-v-acda4dbe]{display:inline-block\n}", ""]);

// exports
